import { Flex, Text } from '@chakra-ui/react'
import React from 'react'

import { textStyleKeys } from '@mangovoice/design-system'

type StatusPillProps = {
  text: string
  bg: string
  color: string
}

export const StatusPill = ({ text, bg, color }: StatusPillProps) => {
  return (
    <Flex
      display="inline-flex"
      alignItems="center"
      justifyContent="flex-start"
      px="0.5rem"
      py="0.25rem"
      borderRadius="0.375rem"
      bg={bg}
      minW={0}
    >
      <Text
        textStyle={textStyleKeys.Body2}
        color={color}
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {text}
      </Text>
    </Flex>
  )
}
